module.exports = __webpack_public_path__ + "static/41invgde-44baa7a46e3e1469f8e2cfc986ac1d67.gif";